import nsiLogo from "./nsi-logo.png";
import nsiLogoWhite from "./nsi_logo_white.png";
import srshLogo from "./SRSH_Care4Dogs_logo.png";
import dogBg from "./background-dog1.jpg";
import dogBg2 from "./dog_background.png";
import dogIcon from "./paw-print-.png";
import sharepointLogo from "./sharepoint-logo.png";
import boneIcon from "./boneIcon.png";
import dogDefault from "./dog_default.png";
import downloadPdf from "./downloadPdf.png";
import dyslasie from "./dysplasies.png";
import puppies from "./puppies.png";
import cross from "./x.png";
import fci from "./fci.png";
import not_fci from "./not_fci.png";

const assets = {
  images: {
    nsiLogo,
    nsiLogoWhite,
    srshLogo,
    dogBg,
    dogBg2,
    dogIcon,
    sharepointLogo,
    boneIcon,
    dogDefault,
    downloadPdf,
    dyslasie,
    puppies,
    cross,
    fci,
    not_fci,
  },
};

export default assets;
